/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const TransferParty = {
  Source: "source",
  Destination: "destination",
  Partner: "partner",
} as const;
export type TransferParty = ClosedEnum<typeof TransferParty>;

/** @internal */
export const TransferParty$inboundSchema: z.ZodNativeEnum<
  typeof TransferParty
> = z.nativeEnum(TransferParty);
/** @internal */
export const TransferParty$outboundSchema: z.ZodNativeEnum<
  typeof TransferParty
> = TransferParty$inboundSchema;
